import api from './api';
import { PaginatedResponse, ScoreSnapshot, RuleTrigger, ScoringHistoryItem } from '../types';

export const scoringApi = {
  // Vendor endpoints
  getVendorScoreHistory: (entityType: string, entityId: string) =>
    api.get<PaginatedResponse<ScoreSnapshot>>(
      `/vendor/score-history/`, { params: { entity_type: entityType, entity_id: entityId } }
    ).then(r => r.data),

  getVendorRuleTriggers: (entityType: string, entityId: string, weekStart?: string) =>
    api.get<PaginatedResponse<RuleTrigger>>(
      `/vendor/rule-triggers/`, { params: { entity_type: entityType, entity_id: entityId, ...(weekStart && { week_start: weekStart }) } }
    ).then(r => r.data),

  getVendorScoringHistory(params?: { entity_type?: string; entity_id?: string; page?: number }) {
    return api.get<PaginatedResponse<ScoringHistoryItem>>('/vendor/scoring-history/', { params });
  },

  // Client endpoints
  getClientScoreHistory: (entityType: string, entityId: string) =>
    api.get<PaginatedResponse<ScoreSnapshot>>(
      `/client/score-history/`, { params: { entity_type: entityType, entity_id: entityId } }
    ).then(r => r.data),

  getClientRuleTriggers: (entityType: string, entityId: string, weekStart?: string) =>
    api.get<PaginatedResponse<RuleTrigger>>(
      `/client/rule-triggers/`, { params: { entity_type: entityType, entity_id: entityId, ...(weekStart && { week_start: weekStart }) } }
    ).then(r => r.data),

  getClientScoringHistory(params?: { entity_type?: string; entity_id?: string; page?: number }) {
    return api.get<PaginatedResponse<ScoringHistoryItem>>('/client/scoring-history/', { params });
  },
};
